


















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class DragBar extends Vue {
	/**
	 * Mac OS：frame按钮鼠标移入移出，点击事件
	 */
	showHoverIcon: boolean = false;

	isFullScreen = false;

	hoverFrameIcon() {
		this.showHoverIcon = true;
	}
	leaveFrameIcon() {
		this.showHoverIcon = false;
	}

	closeWindow() {
		this.$confirm("亲,确定要退出程序吗?", "友情提醒").then(() => {
			Vue.utils.sendToElectron("close");
		});
	}
	minWindow() {
		Vue.utils.sendToElectron("min");
	}
	maxWindow() {
		this.isFullScreen = !this.isFullScreen;
		Vue.utils.sendToElectron("max", this.isFullScreen);
	}

	changeTab(i: number) {
		this.$store.state.currentTab = i;
	}
	delTab(i: number) {
		if (this.$store.state.currentTab === i) {
			this.$store.state.tabs.splice(i, 1);
			this.$store.state.currentTab = i - 1;
			console.log(this.$store.state)
		} else {
			this.$store.state.tabs.splice(i, 1);
		}
	}
}
